import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import IntegrationsLayout from "../../layouts/IntegrationsLayout";

import { TicketsIntegrationPage } from "../../pages/features/integrations/tickets/TicketsPage";
import { EmailIntegrationPage } from "../../pages/features/integrations/email/EmailIntegrationPage";
import { WebRTCIntegrationPage } from "../../pages/features/integrations/calls/WebRTCIntegratioPage";
import { SmsIntegrationPage } from "../../pages/features/integrations/sms/SmsIntegrationPage";
import { WhatsappIntegrationPage } from "../../pages/features/integrations/whatsapp/WhatsappIntegrationPage";

export default function IntegrationNav() {
  return (
    <IntegrationsLayout role="entreprise">
      <Routes>
        <Route path="/" element={<Navigate to="tickets" replace />} />
        <Route path="/tickets" element={<TicketsIntegrationPage />} />
        <Route path="/sms" element={<SmsIntegrationPage />} />
        <Route path="/whatsapp" element={<WhatsappIntegrationPage />} />
        <Route path="/email" element={<EmailIntegrationPage />} />
        <Route path="/webrtc" element={<WebRTCIntegrationPage />} />
      </Routes>
    </IntegrationsLayout>
  );
}
